import React from 'react';
import { FiAlertTriangle } from 'react-icons/fi';
// Import * as is heavy, but needed for dynamic 'name' prop support.
// We wrap it in try-catch to be safe.
import * as FiIcons from 'react-icons/fi';

const SafeIcon = ({ icon, name, className, ...props }) => {
  try {
    // 1. Priority: Direct component passed as prop (e.g. icon={FiHome})
    if (icon) {
      return React.createElement(icon, { className, ...props });
    }

    // 2. Fallback: Dynamic name string (e.g. name="Home")
    if (name) {
      const iconName = `Fi${name}`;
      const IconComponent = FiIcons[iconName];
      
      if (IconComponent) {
        return React.createElement(IconComponent, { className, ...props });
      }
      
      console.warn(`Icon "${iconName}" not found in react-icons/fi`);
    }

    // 3. Fallback: No icon found
    return <FiAlertTriangle className={`text-yellow-500 ${className || ''}`} {...props} />;
    
  } catch (error) {
    console.error("Error rendering SafeIcon:", error);
    return <FiAlertTriangle className={`text-red-500 ${className || ''}`} {...props} />;
  }
};

export default SafeIcon;